function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#hearts_svg__filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.875 49.237c-1.012-2.572-2.42-5.652-1.084-8.369 2.963-6.014 8.853-2.282 12.213.797-.325-.29 8.094-9.311 11.635-1.558 3.83 8.442-8.455 18.768-14.02 22.898-3.505-3.768-6.901-8.949-8.744-13.768z",
  fill: "url(#hearts_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.878 49.237c-1.012-2.572-2.42-5.652-1.084-8.369 2.963-6.014 8.853-2.282 12.213.797-.325-.29 8.094-9.311 11.635-1.558 3.866 8.406-8.42 18.731-14.02 22.862-3.505-3.732-6.865-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.917 49.237c-1.012-2.572-2.421-5.652-1.084-8.369 2.963-6.014 8.853-2.282 12.213.797-.325-.29 8.094-9.311 11.635-1.558 3.866 8.406-8.419 18.731-14.02 22.862-3.505-3.732-6.901-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.875 97.134c-1.012-2.572-2.42-5.652-1.084-8.37 2.963-6.014 8.853-2.282 12.213.798-.325-.29 8.094-9.311 11.635-1.558 3.83 8.442-8.455 18.767-14.02 22.861-3.505-3.768-6.901-8.949-8.744-13.731z",
  fill: "url(#hearts_svg__paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.878 97.134c-1.012-2.572-2.42-5.652-1.084-8.37 2.963-6.014 8.853-2.282 12.213.798-.325-.29 8.094-9.311 11.635-1.558 3.866 8.405-8.42 18.731-14.02 22.861-3.505-3.768-6.865-8.949-8.744-13.731z",
  fill: "url(#hearts_svg__paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.917 97.134c-1.012-2.572-2.421-5.652-1.084-8.37 2.963-6.014 8.853-2.282 12.213.798-.325-.29 8.094-9.311 11.635-1.558 3.866 8.405-8.419 18.731-14.02 22.861-3.505-3.768-6.901-8.949-8.744-13.731z",
  fill: "url(#hearts_svg__paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.875 144.994c-1.012-2.572-2.42-5.652-1.084-8.369 2.963-6.014 8.853-2.282 12.213.797-.325-.29 8.094-9.311 11.635-1.558 3.866 8.406-8.42 18.731-14.02 22.862-3.505-3.732-6.901-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.878 144.994c-1.012-2.572-2.42-5.652-1.084-8.369 2.963-6.014 8.853-2.282 12.213.797-.325-.29 8.094-9.311 11.635-1.558 3.866 8.406-8.42 18.731-14.02 22.862-3.505-3.732-6.865-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.917 144.994c-1.012-2.572-2.421-5.652-1.084-8.369 2.963-6.014 8.853-2.282 12.213.797-.325-.29 8.094-9.311 11.635-1.558 3.866 8.406-8.419 18.731-14.02 22.862-3.505-3.732-6.901-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.897 49.237c-1.012-2.572-2.421-5.652-1.084-8.369 2.962-6.014 8.852-2.282 12.213.797-.326-.29 8.093-9.311 11.634-1.558 3.866 8.406-8.419 18.731-14.019 22.862-3.505-3.732-6.866-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint9_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.936 49.237c-1.012-2.572-2.421-5.652-1.084-8.369 2.963-6.014 8.852-2.282 12.213.797-.326-.29 8.093-9.311 11.634-1.558 3.867 8.406-8.419 18.731-14.019 22.862-3.505-3.732-6.902-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336.939 49.237c-1.012-2.572-2.421-5.652-1.084-8.369 2.962-6.014 8.852-2.282 12.212.797-.325-.29 8.094-9.311 11.635-1.558 3.866 8.406-8.419 18.731-14.019 22.862-3.469-3.732-6.866-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint11_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.897 97.134c-1.012-2.572-2.421-5.652-1.084-8.37 2.962-6.014 8.852-2.282 12.213.798-.326-.29 8.093-9.311 11.634-1.558 3.866 8.405-8.419 18.731-14.019 22.861-3.505-3.768-6.866-8.949-8.744-13.731z",
  fill: "url(#hearts_svg__paint12_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.936 97.134c-1.012-2.572-2.421-5.652-1.084-8.37 2.963-6.014 8.852-2.282 12.213.798-.326-.29 8.093-9.311 11.634-1.558 3.867 8.405-8.419 18.731-14.019 22.861-3.505-3.768-6.902-8.949-8.744-13.731z",
  fill: "url(#hearts_svg__paint13_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336.939 97.134c-1.012-2.572-2.421-5.652-1.084-8.37 2.962-6.014 8.852-2.282 12.212.798-.325-.29 8.094-9.311 11.635-1.558 3.866 8.405-8.419 18.731-14.019 22.861-3.469-3.768-6.866-8.949-8.744-13.731z",
  fill: "url(#hearts_svg__paint14_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.897 144.994c-1.012-2.572-2.421-5.652-1.084-8.369 2.962-6.014 8.852-2.282 12.213.797-.326-.29 8.093-9.311 11.634-1.558 3.866 8.406-8.419 18.731-14.019 22.862-3.505-3.732-6.866-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint15_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.936 144.994c-1.012-2.572-2.421-5.652-1.084-8.369 2.963-6.014 8.852-2.282 12.213.797-.326-.29 8.093-9.311 11.634-1.558 3.867 8.406-8.419 18.731-14.019 22.862-3.505-3.732-6.902-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint16_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336.939 144.994c-1.012-2.572-2.421-5.652-1.084-8.369 2.962-6.014 8.852-2.282 12.212.797-.325-.29 8.094-9.311 11.635-1.558 3.866 8.406-8.419 18.731-14.019 22.862-3.469-3.732-6.866-8.913-8.744-13.732z",
  fill: "url(#hearts_svg__paint17_linear)"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint0_linear",
  x1: 37.366,
  y1: 49.987,
  x2: 12.244,
  y2: 49.987,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint1_linear",
  x1: 102.381,
  y1: 49.969,
  x2: 77.247,
  y2: 49.969,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint2_linear",
  x1: 167.42,
  y1: 49.969,
  x2: 142.286,
  y2: 49.969,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint3_linear",
  x1: 37.366,
  y1: 97.866,
  x2: 12.244,
  y2: 97.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint4_linear",
  x1: 102.381,
  y1: 97.866,
  x2: 77.247,
  y2: 97.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint5_linear",
  x1: 167.42,
  y1: 97.866,
  x2: 142.286,
  y2: 97.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint6_linear",
  x1: 37.378,
  y1: 145.726,
  x2: 12.244,
  y2: 145.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint7_linear",
  x1: 102.381,
  y1: 145.726,
  x2: 77.247,
  y2: 145.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint8_linear",
  x1: 167.42,
  y1: 145.726,
  x2: 142.286,
  y2: 145.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint9_linear",
  x1: 230.4,
  y1: 49.969,
  x2: 205.266,
  y2: 49.969,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint10_linear",
  x1: 295.439,
  y1: 49.969,
  x2: 270.305,
  y2: 49.969,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint11_linear",
  x1: 360.442,
  y1: 49.969,
  x2: 335.308,
  y2: 49.969,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint12_linear",
  x1: 230.4,
  y1: 97.866,
  x2: 205.266,
  y2: 97.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint13_linear",
  x1: 295.439,
  y1: 97.866,
  x2: 270.305,
  y2: 97.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint14_linear",
  x1: 360.442,
  y1: 97.866,
  x2: 335.308,
  y2: 97.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint15_linear",
  x1: 230.4,
  y1: 145.726,
  x2: 205.266,
  y2: 145.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint16_linear",
  x1: 295.439,
  y1: 145.726,
  x2: 270.305,
  y2: 145.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hearts_svg__paint17_linear",
  x1: 360.442,
  y1: 145.726,
  x2: 335.308,
  y2: 145.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFA088"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E98061"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hearts_svg__filter0_f",
  x: -4,
  y: -4,
  width: 378,
  height: 196,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "effect1_foregroundBlur"
})));
function SvgHearts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 188,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgHearts;